class Accordion {
  constructor() {
    const allAccordion = document.querySelectorAll(".accordion-list");
    allAccordion.forEach(function (current) {
      const allList = document.querySelectorAll(".accordion-single");
      allList.forEach(function (single) {
        single.addEventListener("click", () => {
          single.lastChild.lastChild.classList.toggle("rotate-45");
          single.nextSibling.classList.toggle("accordion-open");
        });
      });
    });
  }
}

export default Accordion;
